import StudentProfile from "@/controllers/student/student-profile.js";
import axios from "axios";
import store from "@/store";
import CONFIG from "@/assets/js/config.custom";

export default {
  extends: StudentProfile,

  data() {
    return {
      hasTuitionPlan: false,
      existingTuitionPlans: [],
      CONFIG,
      is_published: false,
      publishedStatus: {},
      hasPreRegistration: false,
      loadedClassIndices: [],
      collapseIds: [],
      loadingStates: {},
      loadingAttendance: {},
      loadingGrading: {},
      terms: [],
      selectedTermId: null,
      deactivationStudentId: null,
      deactivationReason: '',
      deactivationReasonError: false,
      pendingDeactivationId: null,
      hasSiblingDiscountWarning: false,
      siblingDiscountMessage: '',
      isFinalYear: false,
      passFailStudentId: null,
      teacherHomeroomAssistantClassIds: [],
    };
  },

  methods: {
    async getStudentCampusGrades() {
      await axios.get("/student/campusGrade/" + this.studentInfo.student_id).then(async (res) => {
        let customCampusClasses = this.studentInfo.classes.map(($class, index) => {
          $class.result = res.data[index].result;
          return $class;
        });

        // For teachers, filter to only show homeroom/assistant classes
        if (this.auth('teacher').check()) {
          const teacherClassTypes = store.state.user.class_teacher_types || [];
          this.teacherHomeroomAssistantClassIds = teacherClassTypes
            .filter(t => t.type === CONFIG.TEACHER_ROLE.ID.HOMEROOM || t.type === CONFIG.TEACHER_ROLE.ID.ASSISTANT)
            .map(t => t.class_id);

          customCampusClasses = customCampusClasses.filter($class =>
            this.teacherHomeroomAssistantClassIds.includes($class.class_id)
          );
        }

        this.campusClasses = customCampusClasses;

        [this.campusClassIds, this.campusGradeIds, this.campusClassStudentIds, this.campusGradeIdsForSubject] = await this.campusClasses.reduce(([classIds, gradeIds, classStuIds, campusGradeIdsForSubject], classData) => {
            classIds.push(classData.class_id);
            gradeIds.push(classData.grade_id);
            classStuIds.push(classData.id);
            campusGradeIdsForSubject.push(classData.campus_grade_id);
            return [classIds, gradeIds, classStuIds, campusGradeIdsForSubject];
          },
          [[], [], [], []]
        );
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },
    getSubject(index) {
      const campusGradeId = this.campusClasses && this.campusClasses[index]
        ? this.campusClasses[index].campus_grade_id
        : null;
      if (!campusGradeId) {
        this.$set(this.subjectArr, index, []);
        return Promise.resolve();
      }

      return axios.get("/timetable/subjectByCampusGrade", {
        params: {
          campus_grade_ids: [campusGradeId],
        }
      })
        .then(response => {
          const subjects = Array.isArray(response.data) && Array.isArray(response.data[0])
            ? response.data[0]
            : [];
          this.$set(this.subjectArr, index, subjects);
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.$set(this.subjectArr, index, []);
          this.isLoading = false;
          console.error("Subject API Error", error);
        });
    },

    showRestore(id) {
      this.$router.push({
        name: "studentRestore",
        params: {
          id,
        },
      });
    },

    showEnrollmentForm(id) {
      this.$router.push({
          name: "enrollmentPaymentCreate",
          params: {
              classStudentId: id,
          },
          query: {
              tuitionPaymentId: this.tuitionPaymentId,
          }
      });
    },
    checkTuitionPaymentExist() {
      axios.get('student/has-tuition-plan/' + this.$route.params.id)
      .then((response) => {
        this.hasTuitionPlan = response.data.has_tuition_plan;
        this.tuitionPaymentId = response.data.processing_tuition_plan_id;
        this.existingTuitionPlans = response.data.existing_tuition_plans;
        this.isLoading = false;
      });
    },

    showStatementDetail() {
      this.$router.push({
        name: "studentStatementDetail",
        params: {
          tuitionPaymentId: this.tuitionPaymentId,
        }
      })
    },

    hasTuitionForClass(studentClass) {
      let classId = studentClass.class_id ? studentClass.class_id : studentClass.id;
      let plans = Object.values(this.existingTuitionPlans || {});
      let tuitionPlan = plans.find(plan => plan.class_id == classId);
      if (tuitionPlan) return true;
      return false;
    },

    getPeriodNameForClass(studentClass) {
      // First check if studentClass already has period_name from enrollment data
      if (studentClass.period_name) {
        return studentClass.period_name;
      }
      // Fallback to tuition plans
      let classStudentId = studentClass.class_student_id || studentClass.id;
      let plans = Object.values(this.existingTuitionPlans || {});
      let tuitionPlan = plans.find(plan => plan.class_student_id == classStudentId);
      return tuitionPlan?.period_name || '';
    },

    getPeriodNameForClassById(classId) {
      // First check studentInfo.classes for period_name
      let classes = this.studentInfo?.classes || [];
      let classData = classes.find(c => c.class_id == classId || c.id == classId);
      if (classData?.period_name) {
        return classData.period_name;
      }
      // Fallback to tuition plans
      let plans = Object.values(this.existingTuitionPlans || {});
      let tuitionPlan = plans.find(plan => plan.class_id == classId);
      return tuitionPlan?.period_name || '';
    },

    redirectStatementDetailPage(studentClass) {
      let classId = studentClass.class_id ? studentClass.class_id : studentClass.id;
      let plans = Object.values(this.existingTuitionPlans || {});
      let tuitionPlan = plans.find(plan => plan.class_id == classId);

      if (tuitionPlan) {
        this.$router.push({
          name: "studentStatementDetail",
          params: {
            tuitionPaymentId: tuitionPlan.id,
          }
        })
      }
    },

    downloadPdfForStudentInfo(classStuentId) {
      this.isLoading = true;
      axios.get("/student/downloadReportCard/" + classStuentId + '/' + this.selectedTermId + '/' + store.state.user.campus_id, {
          params: {
            campus_id: store.state.user.campus_id
          },
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          responseType: 'blob' // responseType is a sibling of headers, not a child
        })
        .then(response => {
          if (response.status == 200) {
            var currentDate = new Date();
            const fileName = `reportcard_${this.studentInfo.trashed_student.name}_${currentDate.getFullYear()}${(currentDate.getMonth() + 1) > 9 ? '' : '0'}${currentDate.getMonth()+1}${(currentDate.getDate()) > 9 ? '' : '0'}${currentDate.getDate()}.pdf`;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            this.isLoading = false;
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },

    async checkReportCardStatus() {
      try {
        const termId = this.selectedTermId;
        const status = this.campusClassStudentIds.map(id => {
          return axios.get(`student/check-item-grading-status/${id}/${termId}`)
          .then(response => {
            this.$set(this.publishedStatus, id, response.data.is_published);
          })
          .catch(error => {
            this.$set(this.publishedStatus, id, false);
            console.error(`Status check failed for ID ${id}:`, error);
          })
        });
        await Promise.all(status);
      } catch (error) {
        console.error("Check Item Grading Status Api Error:", error);
      }
    },

    checkPassFailValidate() {
      this.$bvModal.hide('modal-1');
      let request = {
        student_ids: [this.currentId],
      };
      axios.post('/student/checkPassFail', request)
      .then(response => {
        if (response.data.has_pre_reg && !this.isFinalYear) {
            this.hasPreRegistration = true;
            this.year_id = response.data.pre_reg_year_id;
            this.getClass(this.year_id);
            setTimeout(() => {
              this.class_id = response.data.pre_reg_class_id;
            }, 500);
            this.$bvModal.show('modal-2');
        } else {
            this.hasPreRegistration = false;
        }
      })
      .catch(error => {
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            let message = error.response.data.message + '\n\n' + errors['student_ids'];
            alert(message.trim());
          } else if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
      });
    },

    closeModal() {
      if (!this.hasPreRegistration) {
        this.class_id = 0;
        this.year_id = 0;
      }
      this.requiredClass = false;
      this.requiredYear = false;
    },

    async getStudentDetail() {
      var request = {
        params: {
          campus_id: store.state.user.campus_id
        }
      }

      if (this.$route.params.leavedStatus == 'active') {
        await axios.get("/student/profile/" + this.$route.params.id, request)
          .then(async (response) => {
            if (!this.canTeacherAccessStudent(response.data)) {
              this.studentInfo = {};
              return;
            }
            this.studentInfo = response.data;
            this.total_annual = this.studentInfo.classes.reduce((total, cls) => total+cls.annual_fee, 0) + " " + this.settings.currency;
            this.total_monthly = this.studentInfo.classes.reduce((total, cls) => total+cls.monthly_fee, 0) + " " + this.settings.currency;
            this.total_termly = this.studentInfo.classes.reduce((total, cls) => total+(cls.termly_fee || 0), 0) + " " + this.settings.currency;
            this.classIds = this.studentInfo.classes.map( classData => classData.class_id );
            this.gradeIds = this.studentInfo.classes.map( classData => classData.grade_id);
            if (Object.keys(this.studentInfo).length > 0) {
              this.parentInfo = response.data?.trashed_student?.trashed_parent ?? null;
              await this.getStudentCampusGrades();
              this.collapseIds = Array.from({ length: this.campusClasses.length }).fill(false);

              if (this.auth('admin').check()) {
                await this.getLatestNotice();
              }

              await this.getStudentFiles();
              this.getGradeName();
              try {
                this.studentInfo.annual_fee = this.studentInfo?.trashed_student?.trashed_student_grade?.trashed_campus_grade?.trashed_grade_fee_master?.annual_fee ?? '';
              } catch (e) {
                this.studentInfo.annual_fee = 0;
              }
              try {
                this.studentInfo.monthly_fee = this.studentInfo?.trashed_student?.trashed_student_grade?.trashed_campus_grade?.trashed_grade_fee_master?.monthly_fee ?? '';
              }
              catch (e) {
                this.studentInfo.monthly_fee = 0;
              }
            }
            store.state.user.role == 1 ? this.isAdmin = true : this.isAdmin = false;
          }) .catch(error => {
            if (error.response && error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            this.isLoading = false;
            console.log("Active Student Detail API Error", error);
          });
      } else if (this.$route.params.leavedStatus == 'leaved') {
        axios.get("/student/leavedProfile/" + this.$route.params.id, request)
          .then(async (response) => {
            if (!this.canTeacherAccessStudent(response.data)) {
              this.studentInfo = {};
              return;
            }
            this.studentInfo = response.data;
              this.parentInfo = response.data?.trashed_student?.trashed_parent ?? null;
              this.classIds = this.studentInfo?.classes?.map( classData => classData.class_id ) ?? [];
              this.gradeIds = this.studentInfo?.classes?.map( classData => classData.grade_id) ?? [];
              this.collapseIds = Array.from({ length: this.studentInfo?.classes?.length || 0 }).fill(false);

              if (this.auth('admin').check()) {
                await this.getLatestNotice();
              }

              this.getGradeName();
              this.getStudentFiles();
              try {
                this.studentInfo.annual_fee = this.studentInfo?.trashed_student?.trashed_student_grade?.trashed_campus_grade?.trashed_grade_fee_master?.annual_fee ?? '';
              } catch (e) {
                this.studentInfo.annual_fee = 0;
              }
              try {
                this.studentInfo.monthly_fee = this.studentInfo?.trashed_student?.trashed_student_grade?.trashed_campus_grade?.trashed_grade_fee_master?.monthly_fee ?? '';
              }
              catch (e) {
                this.studentInfo.monthly_fee = 0;
              }
          })
          .catch(error => {
            if (error.response && error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }              
            this.isLoading = false;
            console.log("Leaved Student Detail API Error", error);
          });
      }
    },

    canTeacherAccessStudent(student) {
      if (!student || !student.id) {
        return false;
      }
      if (!this.auth('teacher').check()) {
        return true;
      }
      const assignedClassIds = [
        ...(store.state.user.class_teacher_types || []).map(t => t.class_id),
        ...(store.state.user.subject_teachers || []).map(t => t.class_id),
      ];
      return assignedClassIds.some(classId => classId == student.class_id);
    },

    getStudentFiles(page = 1) {
      if (this.auth('teacher').check()) return;
      
      StudentProfile.methods.getStudentFiles.call(this, page)
    },
    
    getGrading() {
      var request = {
        params: {
          student_id: this.studentInfo.student_id,
          class_ids: this.campusClassIds,
          campus_id: store.state.user.campus_id,
          term_id: this.selectedTermId,
        }
      }
      return axios.get("/grading/listForDetail" , request)
        .then(response => {
          this.gradingInfoArr = response.data;
          for(let i in this.gradingInfoArr) {
            const data = this.gradingInfoArr[i];
            this.exam_names_arr[i] = data.filter((item, index, examArr) =>
              index === examArr.findIndex((exam) => exam.exam_id == item.exam_id)
            );
          }
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }           
          this.isLoading = false;
          console.log("Grading API Error", error);
        });
    },

    getAttendanceInfo() {
      var request = {
        params: {
          class_student_id: this.$route.params.id,
          campus_id: store.state.user.campus_id,
          class_ids: this.campusClassIds,
          term_id: this.selectedTermId,
        }
      }
      return axios.get("/studentAttendance/info", request)
      .then(response => {
        this.attendanceInfoArr = response.data;
      })
      .catch(error => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.log("Student Attendance API Error", error);
      });
    },

    toggleCollapse(index) {
      for(let i = 0; i < this.collapseIds.length; i++) {
        if (i !== index) {
          this.$set(this.collapseIds, i, false);
        }
      }

      this.$set(this.collapseIds, index, !this.collapseIds[index]);

      const isClassIndex = this.studentInfo.classes && 
                            index >= 0 && 
                            index < this.studentInfo.classes.length;
      if (this.collapseIds[index] && isClassIndex && !this.loadedClassIndices.includes(index)) {
        this.fetchClassData(index);
        this.loadedClassIndices.push(index);
      }
    },

    async fetchClassData(index) {
      this.$set(this.loadingStates, index, true);
      const classId = this.studentInfo.classes[index].class_id;
      try {
        await this.fetchTermsForStudent(classId);
        await Promise.all([
          this.getTimetableMeta(),
          this.getTimetable(),
          this.getSubject(index),
          this.getGrading(),
          this.getAttendanceInfo(),
          this.checkReportCardStatus(),
      ]);
      } catch (error) {
        console.error("Failed to load class data:", error);
      } finally {
        this.$set(this.loadingStates, index, false);
      }
    },

    async fetchTermsForStudent(classId) {
      if (!classId) {
        this.terms = [];
        return;
      }

      try {
        const response = await axios.get('/term/get-terms-by-class', { params: { class_id: classId } });
        this.terms = response.data.terms || [];
        if (this.terms.length > 0) {
          this.selectedTermId = this.terms[0].id;
        }
      } catch (error) {
        console.error('Failed to fetch terms for student:', error);
      }
    },

    fetchDataByTerm(index) {
      this.$set(this.loadingAttendance, index, true);
      this.$set(this.loadingGrading, index, true);
      this.$set(this.gradingInfoArr, index, []);
      this.$set(this.exam_names_arr, index, []);
      this.$set(this.attendanceInfoArr, index, []);
      Promise.all([
        this.getAttendanceInfo(),
        this.getGrading(),
        this.checkReportCardStatus(),
      ]).finally(() => {
        this.$set(this.loadingAttendance, index, false);
        this.$set(this.loadingGrading, index, false);
      });
    },

    async confirmDelete(id) {
      this.isLoading = true;
      try {
        const response = await axios.post(`/student/deactivate/${id}`);
        this.isLoading = false;

        if (response.data.requires_reason) {
          this.openDeactivateReasonModal(id);
        }
      } catch (error) {
        this.isLoading = false;
        if (error.response && error.response.status === 422 && error.response.data.requires_confirmation) {
          this.siblingDiscountMessage = error.response.data.message || '';
          this.hasSiblingDiscountWarning = true;
          this.pendingDeactivationId = id;
          this.$bvModal.show('modal-deactivate-warning');
        } else {
          let errorMessage = 'An unexpected error occurred.';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
          this.$notification.error(errorMessage, {
            timer: 3,
            position: "bottomCenter"
          });
        }
      }
    },

    proceedWithDeactivateAfterWarning() {
      this.$bvModal.hide('modal-deactivate-warning');
      this.hasSiblingDiscountWarning = false;
      this.siblingDiscountMessage = '';
      const id = this.pendingDeactivationId;
      this.pendingDeactivationId = null;
      this.openDeactivateReasonModal(id);
    },

    cancelDeactivateAfterWarning() {
      this.$bvModal.hide('modal-deactivate-warning');
      this.hasSiblingDiscountWarning = false;
      this.siblingDiscountMessage = '';
      this.pendingDeactivationId = null;
    },

    openDeactivateReasonModal(id) {
      this.deactivationStudentId = id;
      this.deactivationReason = '';
      this.deactivationReasonError = false;
      this.$bvModal.show('modal-deactivate-reason');
    },

    cancelDeactivate() {
      this.deactivationStudentId = null;
      this.deactivationReason = '';
      this.deactivationReasonError = false;
      this.$bvModal.hide('modal-deactivate-reason');
      this.pendingDeactivationId = null;
      this.hasSiblingDiscountWarning = false;
      this.siblingDiscountMessage = '';
      this.$bvModal.hide('modal-deactivate-warning');
    },

    async confirmDeactivationReason() {
      if (!this.deactivationReason) {
        this.deactivationReasonError = true;
        return;
      }
      this.deactivationReasonError = false;
      const id = this.deactivationStudentId;
      const reason = this.deactivationReason;

      this.$bvModal.hide('modal-deactivate-reason');
      this.isLoading = true;

      try {
        const res = await axios.post(`/student/deactivate/${id}`, {
          force_deactivate: 1,
          reason: reason
        });
        if (res.status === 200) {
          this.$notification.success('Student Deactivated Successfully', {
            timer: 3,
            position: "bottomCenter"
          });
          this.$router.push({ name: 'studentList' });
        }
      } catch (error) {
        let errorMessage = 'An error occurred while deactivating the student.';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.$notification.error(errorMessage, {
          timer: 3,
          position: "bottomCenter"
        });
      } finally {
        this.isLoading = false;
        this.cancelDeactivate();
      }
    },

    showModel(id, result) {
      this.currentId = id;
      this.passFailResult = result;
      this.passFailStudentId = id;

      // Check if this is a final year student when passing - call API to verify
      if (result == 1) {
        axios.post('/student/checkPassFail', {
          student_ids: [id],
          result: result
        }, {
          headers: {
            'Content-Type': 'application/json',
          }
        })
          .then(response => {
            if (response.data && response.data.is_final_year) {
              this.isFinalYear = true;
              this.$bvModal.show('modal-final-year-warning');
            } else {
              this.isFinalYear = false;
              this.$bvModal.show('modal-1');
            }
          })
          .catch(() => {
            this.isFinalYear = false;
            this.$bvModal.show('modal-1');
          });
        return;
      }

      this.isFinalYear = false;
      this.$bvModal.show('modal-1');
    },

    proceedFinalYearPass() {
      this.$bvModal.hide('modal-final-year-warning');
      this.clickDisabled = true;
      this.isLoading = true;

      var request = {
        student_ids: [this.passFailStudentId],
        result: this.passFailResult,
        campusMaxGrade: this.maxGradeId,
        campus_id: store.state.user.campus_id,
        created_id: store.state.user.id,
        selected_class_id: 0,
        selected_year_id: 0
      }

      axios.post("/student/setPassFail", request, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(() => {
          this.clickDisabled = false;
          this.isLoading = false;
          this.$notification.success("Student Graduated Successfully", {
            timer: 3,
            position: "bottomCenter"
          });
          this.$router.push({ name: "studentList" });
        })
        .catch(error => {
          this.clickDisabled = false;
          this.isLoading = false;
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.log("Graduation Error", error);
        });
    },
  },

  async mounted() {
    this.isLoading = true;
    this.getSetting();
    await this.getStudentDetail();
    this.getMaxGradeByCampus();

    if (this.auth('admin').check()) {
      this.checkTuitionPaymentExist();
    } else {
      this.isLoading = false;
    }

    this.getReligion();
    this.getAcademicYear();
  },
};
